import {gql} from '@apollo/client'

export const CREATE_UPDATE_CLIENT = gql`
  mutation clientCreateUpdate($input: ClientCreateUpdateInput!) {
    clientCreateUpdate(input: $input) {
      client {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`
export const CREATE_PRICE_CLIENT = gql`
  mutation clientAssingProduct($input: AssignProductClientInput!) {
    clientAssingProduct(input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_ONE_PRICE = gql`
  mutation productPriceClientDelete($input: ProducPricetClientDeleteInput!) {
    productPriceClientDelete(input: $input) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const EDIT_ONE_PRICE = gql`
  mutation productPriceClientUpdate($input: ProducPricetClientUpdateInput!) {
    productPriceClientUpdate(input: $input) {
      success
      errors {
        message
      }
    }
  }
`
